import { PriceMovementGraphType, PriceMovementDuration } from "enums";
import moment from "moment";

export const dashboardFilterState = (dateTimeOnboarded) => ({
  graphType: PriceMovementGraphType.priceMovements,
  dateSelection: PriceMovementDuration.dateRange,
  startDate: moment(dateTimeOnboarded),
  endDate: moment(),
});
